<div>
  <h2>404 - Seite nicht gefunden</h2>
  <p>
    Diese Seite existiert nicht. Möglicherweise wurde der Inhalt entfernt oder auf eine andere URL
    verlegt.
  </p>
</div>
